import React from 'react';
import { ButtonProps } from '../types';

const Button = ({
    children,
    onClick,
    variant = 'primary',
    className = '',
    type = 'button',
    fullWidth = false,
    theme = 'light',
    disabled = false
}: ButtonProps & { theme?: 'light' | 'dark' }) => {
    const baseStyle = "px-6 py-2.5 rounded-full font-bold tracking-wide transition-all duration-300 flex items-center justify-center gap-2 transform active:scale-95";

    const variants = {
        primary: "bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white shadow-lg shadow-violet-500/30 hover:shadow-violet-500/50 hover:scale-105 border-0",
        secondary: theme === 'dark'
            ? "bg-zinc-800 text-white border border-zinc-700 hover:border-violet-400 hover:text-violet-400 shadow-sm"
            : "bg-white text-zinc-900 border border-zinc-200 hover:border-violet-500 hover:text-violet-600 shadow-sm",
        danger: theme === 'dark'
            ? "bg-red-900/20 text-red-400 hover:bg-red-900/40 border border-red-800"
            : "bg-red-50 text-red-600 hover:bg-red-100 border border-red-200",
        outline: theme === 'dark'
            ? "border-2 border-zinc-700 text-zinc-400 hover:border-zinc-200 hover:text-zinc-200"
            : "border-2 border-zinc-300 text-zinc-600 hover:border-zinc-900 hover:text-zinc-900",
        text: theme === 'dark'
            ? "text-zinc-400 hover:text-violet-400 hover:bg-zinc-800/50 rounded-lg"
            : "text-zinc-600 hover:text-violet-600 hover:bg-zinc-100 rounded-lg",
         disabledStyle: theme === 'dark'
            ? "opacity-50 cursor-not-allowed bg-zinc-300 text-zinc-500 shadow-none hover:scale-100"
            : "opacity-50 cursor-not-allowed bg-zinc-200 text-zinc-400 shadow-none hover:scale-100"

    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseStyle} ${variants[variant]} ${disabled ? variants.disabledStyle : ''} ${fullWidth ? 'w-full' : ''} ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;